import { render, staticRenderFns } from "./FaqModal.vue?vue&type=template&id=24e2e832&"
import script from "./FaqModal.vue?vue&type=script&lang=js&"
export * from "./FaqModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports